import React, { useEffect } from "react";
import './event.css'
// Import images
import event1 from "../../../img/india_soft_2025.jpg";
import event2 from "../../../img/india_soft_2025_1.jpg";
import event3 from "../../../img/india_soft_2025_2.jpg";
import event4 from "../../../img/india_soft_2025_3.jpg";
import event5 from "../../../img/india_soft_2025_4.jpg";
import event6 from "../../../img/india_soft_2025_5.jpg";
import event7 from "../../../img/india_soft_2025_6.jpg";
import event8 from "../../../img/india_soft_2025_7.jpg";
import event9 from "../../../img/india_soft_2025_8.jpg";
import event10 from "../../../img/india_soft_2025_9.jpg";
import event11 from "../../../img/india_soft_2025_10.jpg";
import event12 from "../../../img/india_soft_2025_11.jpg";
import event13 from "../../../img/india_soft_2025_12.jpg";
import event14 from "../../../img/india_soft_2025_13.jpg";
import event15 from "../../../img/india_soft_2025_14.jpg";
import event16 from "../../../img/india_soft_2025_15.jpg";
import event17 from "../../../img/india_soft_2025_16.jpg";
import event18 from "../../../img/india_soft_2025_17.jpg";
import event19 from "../../../img/india_soft_2025_18.jpg";

import logo from "../../../img/CodeQlik_logo.png";



const Events = () => {

const text = "INDIA SOFT 2025";
  useEffect(() => {
    const letters = document.querySelectorAll(".letter");
    letters.forEach((letter, index) => {
      setTimeout(() => {
        letter.classList.add("show");
      }, index * 100); // delay for sequential effect
    });
  }, []);
  return (
    <div>
        <div className="container event_working">
    {/* <!-- <div className="event_text">
    <h2>Event</h2>
</div> --> */}
    <span className="tm-hero-subtitle">EVENTS </span>


    <div className="evnet glow" id="text">
        <span className="letter">I</span>
        <span className="letter">N</span>
        <span className="letter">D</span>
        <span className="letter">I</span>
        <span className="letter">A</span>
        <span className="letter"> </span>
        <span className="letter">S</span>
        <span className="letter">O</span>
        <span className="letter">F</span>
        <span className="letter">T</span>
        <span className="letter"> </span>
        <span className="letter">2</span>
        <span className="letter">0</span>
        <span className="letter">2</span>
        <span className="letter">5</span>
    </div>

</div>


<div className="container-fluid">
      <div className="masonry-container">
        <div className="masonry-item">
          <span>
            <img src={event1} alt="Item 1" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event2} alt="Item 2" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event3} alt="Item 3" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event4} alt="Item 4" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event5} alt="Item 5" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event6} alt="Item 6" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event7} alt="Item 7" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event8} alt="Item 8" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event9} alt="Item 9" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event10} alt="Item 10" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event11} alt="Item 11" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event12} alt="Item 12" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event13} alt="Item 13" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event14} alt="Item 14" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event15} alt="Item 15" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event16} alt="Item 16" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event17} alt="Item 17" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event18} alt="Item 18" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
        <div className="masonry-item">
          <span>
            <img src={event19} alt="Item 19" />
            <img className="logo" src={logo} alt="Logo" />
          </span>
        </div>
      </div>
    </div>
</div>
  )
}

export default Events